import React, { useMemo } from 'react';

import { useTranslation } from 'hooks/useTranslation';
import BaseButton from 'features/app/components/BaseButton';
import { dashboardPaths } from 'features/dashboard/routes/paths';
import useUser from 'features/user/hooks/useUser';
import { useStyles } from 'features/dashboard/components/SendGiftButtons/styles';
import { ReactComponent as SendGiftsIcon } from 'assets/images/start-rewarding-now.svg';
import { useSubscription } from 'features/user/hooks/useSubscription';

export const SendGiftButtons = () => {
  const { t } = useTranslation('dashboard');
  const { user } = useUser();
  const { isSubscriptionActive } = useSubscription();
  const registration_request_status = user?.registration_request_status;
  const isDisabled = useMemo(
    () =>
      registration_request_status === 'PENDING_VERIFICATION' ||
      registration_request_status === 'PENDING_ACTION' ||
      registration_request_status === 'PENDING_REVIEW' ||
      registration_request_status === 'REJECTED' ||
      !isSubscriptionActive,
    [registration_request_status, isSubscriptionActive]
  );

  const classes = useStyles({ isDisabled });

  return (
    <div className={classes.sendGiftsContainer}>
      <div className={classes.squares} />
      <div className={classes.sendGiftsWrapper}>
        <div className={classes.sendGiftsTitle}>
          <p>{t('startRewardingNow')}</p>
        </div>
        <div className={classes.sendGiftsButtons}>
          <BaseButton
            maxWidth={253}
            variant="text"
            to={isDisabled ? '#' : dashboardPaths.static.sendSingleGift}
            disabled={isDisabled}
            className={classes.singleGiftsButton}
          >
            {t('sendSingleReward')}
          </BaseButton>
          <BaseButton
            maxWidth={253}
            variant="text"
            to={isDisabled ? '#' : dashboardPaths.static.sendGiftInBulk}
            disabled={isDisabled}
            className={classes.bulkGiftsButton}
          >
            {t('sendRewardsInBulk')}
          </BaseButton>
        </div>
      </div>
      <div className={classes.sendGiftsIcon}>
        <SendGiftsIcon className={classes.svgIcon} />
        <div className={classes.dots} />
      </div>
    </div>
  );
};
